import { Action } from 'react-fetching-library';

export const getPostList: Action = {
  method: 'GET',
  endpoint: 'items/articles',
};
